import {userCookieUtils} from 'common/report/util/user-identity-from-cookie';
import {getUserAccess} from 'common/report/util/saved-entities';
import {Content} from 'common/types/app-api/content';

export enum TrackingEvent {
  // Content sidenav actions
  ClickDuplicateContent = `Clicked duplicate content`,
  ClickedDeleteContent = `Clicked delete content`,
  DeleteContent = `Delete content`,
  DuplicateContent = `Duplicate content`,
  SelectContent = `Select content`,

  // Favoriting
  Favorited = `Favorited content`,
  Unfavorited = `Unfavorited content`,

  // Pinning
  Pinned = `Pinned content`,
  Unpinned = `Unpinned content`,

  // Updateing
  Renamed = `Renamed content`,

  CopySidenavLink = `Copy Sidenav Link`,
  ContentSidenavOverflowMenuActionSelected = `Content Sidenav Overflow Menu Action Selected`,
}

export enum TrackingSource {
  Header = `header`,
  Sidenav = `sidenav`,
}

type TrackContentActionParams = {
  event: TrackingEvent;
  content: Partial<Content>;
  props?: Obj;
  source?: TrackingSource;
};
export function trackContentAction({event, content, props, source}: TrackContentActionParams) {
  props = props || {};
  mixpanel.track(`[Content] ${event}`, {
    ...getCommonContentTrackingProps({content, source}),
    ...props,
  });
}

export function getCommonContentTrackingProps({
  content,
  source,
}: {
  content: Partial<Content>;
  source?: TrackingSource;
}): Obj {
  return {
    'content id': content?.id,
    description: content?.description,
    'description - length': content?.description?.length,
    name: content?.name,
    'name - length': content?.name?.length,
    source,
    'permission level': content
      ? getUserAccess(content, {
          ownerId: content.creator_id ?? 0,
          userId: userCookieUtils.getUserIdentityFromCookie()?.id ?? 0,
        })
      : null,
    'Request-URL': window.location.href,
    'content type': content?.content_type,
    timestamp_ms: Date.now(),
  };
}
